import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-main-menu-expand-button',
    templateUrl: './main-menu-expand-button.component.html',
    styleUrls: ['./main-menu-expand-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatIcon]
})
export class MainMenuExpandButtonComponent {
  readonly isWide = input<boolean>(false);
  readonly toggleExpansion = output<void>();
}
